// booking/components/FormSelectField.jsx
import React, { memo } from 'react';
import { TextField, MenuItem } from '@mui/material';

const FormSelectField = memo(
  ({
    name,
    formik,
    children,
    defaultOption = true,
    defaultValue = '',
    value: externalValue,
    onChange: externalOnChange,
    ...props
  }) => {
    const value =
      externalValue !== undefined
        ? externalValue
        : name.includes('.')
          ? name.split('.').reduce((obj, key) => obj?.[key], formik?.values) || defaultValue
          : formik?.values[name] || defaultValue;

    const handleChange = (e) => {
      formik.handleChange(e);
      if (externalOnChange) {
        externalOnChange(e);
      }
    };

    const handleBlur = (e) => {
      formik.handleBlur(e);
      formik.validateField(name);
    };

    // Generar un id único basado en el name
    const fieldId = name.replace(/\./g, '-');

    return (
      <TextField
        {...props}
        error={formik?.touched[name] && Boolean(formik?.errors[name])}
        fullWidth
        helperText={formik?.touched[name] && formik?.errors[name]}
        id={fieldId}
        margin='normal'
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        select
        size='small'
        value={value}
        variant='outlined'
      >
        {defaultOption && <MenuItem value={defaultValue}>Seleccionar</MenuItem>}
        {children}
      </TextField>
    );
  }
);

FormSelectField.displayName = 'FormSelectField';

export default FormSelectField;
